import { render, staticRenderFns } from "./ProjectChip.vue?vue&type=template&id=4ebb8a68"
import script from "./ProjectChip.vue?vue&type=script&lang=ts"
export * from "./ProjectChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ebb8a68')) {
      api.createRecord('4ebb8a68', component.options)
    } else {
      api.reload('4ebb8a68', component.options)
    }
    module.hot.accept("./ProjectChip.vue?vue&type=template&id=4ebb8a68", function () {
      api.rerender('4ebb8a68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/managers/ProjectChip.vue"
export default component.exports